module.exports = __webpack_public_path__ + "img/long_jump.6f4ef7e7.svg";